import { RootState } from '../../../stores/store.ts';

export const selectAccountFavorites = (state: RootState) => state.favorites.items;

export const selectAccountFavoriteByName = (name: string) => (state: RootState) => {
    if (!name) return undefined;

    const searchName = name.toLowerCase().trim();

    return state.favorites.items.find(
        (item) => item.name.toLowerCase().trim() === searchName
    );
};